export default "<a [routerLink]=\"['']\">\r\n  <div class=\"back-button\">\r\n    <i class=\"left\"></i>\r\n  </div>\r\n</a>\r\n"